import { SButton } from '@setvi/shared/components';
import { Box, CircularProgress, Divider, withStyles } from '@material-ui/core';
import { CheckOutlined } from '@material-ui/icons';

interface FooterProps {
  onConfirm: () => void;
  onClose?: () => void;
  confirmLabel?: string;
  closeLabel?: string;
  startIcon?: JSX.Element | null;
  disableConfirm?: boolean;
  disableClose?: boolean;
  confirmLoading?: boolean;
  endIcon?: JSX.Element | null;
  divider?: boolean;
  variantCancel?: 'text' | 'outlined' | 'contained';
  variantConfirm?: 'text' | 'outlined' | 'contained';
}

const FooterWrapper = withStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    padding: spacing(3, 4)
  }
}))(Box);

const SFooter = ({
  onConfirm,
  onClose,
  confirmLabel = 'Confirm',
  closeLabel = 'Close',
  disableConfirm = false,
  disableClose = false,
  confirmLoading = false,
  startIcon = <CheckOutlined />,
  endIcon = null,
  divider = true,
  variantCancel = 'outlined',
  variantConfirm = 'contained'
}: FooterProps) => (
  <>
    {divider && <Divider />}

    <FooterWrapper>
      <SButton
        loading={confirmLoading}
        onClick={onConfirm}
        startIcon={
          confirmLoading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            startIcon
          )
        }
        variant={variantConfirm}
        endIcon={endIcon}
        disabled={disableConfirm}>
        {confirmLabel}
      </SButton>
      {onClose && (
        <SButton
          style={{ width: 100 }}
          color="inherit"
          variant={variantCancel}
          onClick={onClose}
          disabled={disableClose}>
          {closeLabel}
        </SButton>
      )}
    </FooterWrapper>
  </>
);

export default SFooter;
